export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              About Burtman's Painting & Landscape
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Burtman's Painting & Landscape is dedicated to delivering exceptional painting services for homes and businesses. We focus on quality, reliability, and customer satisfaction, transforming spaces and yards with expert craftsmanship and attention to detail.
            </p>

            <div className="grid grid-cols-3 gap-6">
              <div className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-sm font-bold text-gray-900">Licensed</h3>
              </div>
              <div className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-star-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-sm font-bold text-gray-900">Insured</h3>
              </div>
              <div className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-map-pin-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-sm font-bold text-gray-900">Local</h3>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="h-64 w-full rounded-lg overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/604cbbd1e3813e242591c08075ed2735.jpg" 
                alt="Professional painting service" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="h-64 w-full rounded-lg overflow-hidden mt-8">
              <img 
                src="https://readdy.ai/api/search-image?query=Landscape%20professional%20working%20on%20beautiful%20garden%20design%20planting%20colorful%20flowers%20and%20trimming%20green%20hedges%20with%20gardening%20tools%20and%20equipment%20nearby%20wearing%20work%20gloves%20creating%20attractive%20outdoor%20space%20with%20mulch%20and%20plants%20in%20sunny%20weather%20showing%20expertise%20in%20landscaping%20services&width=400&height=500&seq=about-img-002&orientation=portrait" 
                alt="Professional landscaping service" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="h-64 w-full rounded-lg overflow-hidden -mt-8">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20lush%20green%20residential%20lawn%20with%20perfectly%20manicured%20grass%20freshly%20mowed%20with%20clean%20edges%20and%20stripes%20showing%20professional%20lawn%20care%20maintenance%20service%20results%20in%20bright%20sunny%20day%20with%20healthy%20thick%20turf%20and%20neat%20borders%20demonstrating%20expert%20landscaping%20quality&width=400&height=500&seq=about-img-lawn-005&orientation=portrait" 
                alt="Professional lawn care" 
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="h-64 w-full rounded-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20completed%20home%20exterior%20renovation%20showing%20freshly%20painted%20siding%20in%20modern%20colors%20with%20perfectly%20maintained%20green%20lawn%20colorful%20flower%20beds%20and%20trimmed%20bushes%20under%20blue%20sky%20demonstrating%20professional%20quality%20painting%20and%20landscaping%20work%20with%20excellent%20curb%20appeal&width=400&height=500&seq=about-img-004&orientation=portrait" 
                alt="Completed project" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
